import gql from 'graphql-tag';

export default gql`
    query GetAvailableDriversForJob($jobId: Int) {
        getAvailableDriversForJob(jobId: $jobId) {
            id
            driverId
            name
            companyName
            jobName
            notes
        }
    }
`;
